<template>
  <div class="rank-result">
    <List
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRankList"
    >
      <Row :gutter="16" class="list" v-if="rankList.length">
        <Col v-for="(item, index) in rankList" :key="index" span="12">
          <div
            class="item"
          >
            <div class="cover">
              <mVideo :videoUrl="item.mediaurl" height="2.4rem" fit="cover"/>
            </div>
            <div class="info">
              <div class="name">{{ item.name || item.nickname }}</div>
            </div>
          </div>
        </Col>
      </Row>
    </List>
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col } from "vant";
import mVideo from "@/components/mVideo/index";
export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
    borderRadius() {
      if (this.filter) {
        let i = this.filter.findIndex((row) => {
          return row.active == 1;
        });
        if (i == 0) {
          return "0 .2rem .2rem .2rem";
        } else {
          return ".2rem";
        }
      }
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
    mVideo
  },
  props: ["item_sub_id", "sports_id", "item_id"],
  data() {
    return {
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
    };
  },
  methods: {
    onChange(row) {
      if (this.loading) return;
      this.filter.forEach((item) => {
        item.active = 0;
      });
      row.active = 1;
      this.register_type = row.value;
      this.rankList = [];
      this.page = 1;
      this.getRankList();
    },
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      if (!+this.item_sub_id) {
        this.$api.sports
          .getSportsItemRank({ id: this.item_id, page: this.page })
          .then((res) => {
            let { page, list } = res.data;
            this.systime = res.sys_time;
            this.loading = false;
            if (+page.currentPage === 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }

            let t = null

            this.rankList.forEach((item, index) => {
              item = Object.assign(item, item.userInfo);
              item.score = +item.total_score ? item.total_score : 0;
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.score*1 == t.score*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })

            if (+page.currentPage >= page.pageCount) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
      } else {
        this.$api.sports
          .compareRank2(
            Object.assign({
              cpgid: this.item_sub_id,
              page: this.page,
              sort: 2,
              register_type: this.register_type,
            })
          )
          .then((res) => {
            if (+res.status !== 200) {
              this.finished = true;
              return;
            }
            this.systime = res.sys_time;
            this.loading = false;
            let {
              list,
              page,
              pages,
              myinfo,
              type,
              physical_item_id,
            } = res.data;
            this.myinfo = myinfo;
            this.type = type;
            this.physical_item_id = physical_item_id;
            this.filter = res.data.filter;
            if (page == 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }

            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.score*1 == t.score*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })

            if (page >= pages) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
      }
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      this.$api.sports.sportsMain(this.sports_id).then((res) => {
        let { bgstyle, id, tabstyle, introstyle, title } = res.data;
        try {
          bgstyle = JSON.parse(bgstyle);
          tabstyle = JSON.parse(tabstyle);
          introstyle = JSON.parse(introstyle);
        } catch (e) {
          console.error(e);
        }
        this.detail = { id, bgstyle, tabstyle, introstyle, title };
        this.$toast.clear();
      });

      if (!+this.item_sub_id) {
        this.$api.sports
          .getMySportsItemRank({ id: this.item_id })
          .then((res) => {
            this.myinfo = res.data;
          });
      }
    },
  },
  mounted() {
    this.init();
    // this.getRankList();
  },
};
</script>
